import { CONFIG } from '../../../Config/config'
import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

export const getLocationInPostcodesAndCvrPercentiles = async cityId => {
  const query = `query ($cityId: ID!) {
      city(id: $cityId) {
          name
          cvrPercentiles{
            p5
            p25
            p50
            p75
            p95
          }
          postcodesAndLocationsInsideDistributionZones{
            postcodes{
              postcode
              locations{
                id
                name
                isEvent
                isSheltered
                latitude
                longitude
                typeId
              }
            }
            isDistributionZoneExists
          }
        }
      }
    `

  return await callAuthorizedGraphQLEndpoint(query, {
    cityId,
  })
}

export const createMissions = async ({
  missionsByChunks,
  totalAmount,
  onProgress,
  campaignId,
}) => {
  const mutation = `
  mutation createMissions ($input: CreateMissionsInput!) {
    createMissions(input: $input) {
      missions { 
        id
        status
        dateTime
        distributionCost
        costPerFlyer
        draftPayAdjustment
        printingCostPerFlyer
        bonusPerConversion
        bonusRedemptionPeriod
        type
        label
        location {
          id
          name
          hasPermit
          rank
          detailedRank
          type {
            name
          }
        }
        cityPlan { 
          id 
        }
        boundary {
          latitude
          longitude
        }
        boundaryColour
        amountScans
        campaign { id, name }
      }
    }
  }
`

  let createdMissions = []

  for (let index = 0; index < missionsByChunks.length; index++) {
    const missionsInChunk = missionsByChunks[index]
    const variables = {
      input: {
        missions: missionsInChunk,
        relatedCampaign: +campaignId || null,
      },
    }
    const req = await callAuthorizedGraphQLEndpoint(mutation, variables, {
      ignoreErrors: true,
    })
    const result = await req.json()

    createdMissions = [
      ...createdMissions,
      ...((result.data.createMissions && result.data.createMissions.missions) ||
        []),
    ]
    if (onProgress) {
      onProgress({
        processedAmount: createdMissions.length,
        totalAmount,
      })
    }
  }
  return createdMissions
}

export const sendRosterFeedback = async ({ data, generationId }) => {
  const mutation = `
  mutation sendRosterFeedback($input: SendRosterFeedbackInput!) {
    sendRosterFeedback(input: $input) {
      success
    }
  }
`
  await callAuthorizedGraphQLEndpoint(mutation, {
    input: {
      data: JSON.stringify(data),
      generationId,
    },
  })
}

export const getLoactionByAI = async payload => {
  const url = `${CONFIG.OPPIZI_ML_API_URL}/mission/mission_generator`

  const req = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': `8euHDMFhnha1wFjfExEqp7iPEAOfVHfX42Xzu8J3`,
    },
    body: JSON.stringify(payload),
  })
  if (req.status === 500) {
    throw new Error(500)
  }
  const resp = await req.json()
  return resp
}

export const getLoactionCvr = async payload => {
  const url = `${CONFIG.OPPIZI_ML_API_URL}/mission/predict_cvr`

  const req = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': `8euHDMFhnha1wFjfExEqp7iPEAOfVHfX42Xzu8J3`,
    },
    body: JSON.stringify(payload),
  })
  if (req.status === 500) {
    throw new Error(500)
  }
  const resp = await req.json()
  return resp
}
